export default {
  link: 'https://xn--80abetlybeo6ie.xn--p1ai/',
  previewSrc: 'war-images-3.png',
  title: 'Образы войны',
  announce:
    'Проект приурочен к 75-летию Великой победы и призван донести до широкой аудитории свидетельства беспримерного подвига советского народа, отстоявшего свободу и независимость Родины',
  model_type: 'specialprojectsection',
  type: 'second',
  gallery: [
    {
      previewSrc:
        'https://api.ov.histrf.ru/media/filer_public_thumbnails/filer_public/2f/73/2f736790-eef0-40f3-9856-011ef0467d7f/20.jpg__500x300_q85_subsampling-2.jpg',
      title: 'Битва за Берлин',
      link: 'https://xn--80abetlybeo6ie.xn--p1ai/themes/bitva-za-berlin/?page=1',
    },
    {
      previewSrc:
        'https://api.ov.histrf.ru/media/filer_public_thumbnails/filer_public/11/05/1105cfef-ed68-4829-884a-030bc7efb88a/0-95951.jpg__500x300_q85_subsampling-2.jpg',
      title: 'Битва за Кавказ',
      link: 'https://xn--80abetlybeo6ie.xn--p1ai/themes/bitva-za-kavkaz/?page=1',
    },
    {
      previewSrc:
        'https://api.ov.histrf.ru/media/filer_public_thumbnails/filer_public/3c/7b/3c7bed58-b72b-473e-bfdc-f7f0c47ae6e7/kp408_292_21783.jpg__500x300_q85_subsampling-2.jpg',
      title: 'Заполярье и Карельский фронт',
      link: 'https://xn--80abetlybeo6ie.xn--p1ai/themes/vojna-v-zapolyare/?page=1',
    },
    {
      previewSrc:
        'https://api.ov.histrf.ru/media/filer_public_thumbnails/filer_public/50/92/5092acca-0a10-403b-b7b2-73af985b1d7d/kp408_337_21828.jpg__500x300_q85_subsampling-2.jpg',
      title: 'Нацистские преступления и Нюрнбергский процесс',
      link: 'https://xn--80abetlybeo6ie.xn--p1ai/themes/nacistskie-prestupleniya-i-nyurnberg/?page=1',
    },
    {
      previewSrc:
        'https://api.ov.histrf.ru/media/filer_public_thumbnails/filer_public/02/f8/02f8f52b-b70c-41c1-83dc-decb018d6020/0-154999.jpg__500x300_q85_subsampling-2.jpg',
      title: 'Оборона и блокада Ленинграда',
      link: 'https://xn--80abetlybeo6ie.xn--p1ai/themes/oborona-leningrada/?page=1',
    },
    {
      previewSrc:
        'https://api.ov.histrf.ru/media/filer_public_thumbnails/filer_public/74/04/7404a60f-8b61-4b96-9967-6cf985d43283/0-55010.jpg__500x300_q85_subsampling-2.jpg',
      title: 'Сражения под Ржевом',
      link: 'https://xn--80abetlybeo6ie.xn--p1ai/themes/rzhevskaya-bitva/?page=1',
    },
    {
      previewSrc:
        'https://api.ov.histrf.ru/media/filer_public_thumbnails/filer_public/81/83/8183ee45-2549-4afb-85c2-95b415534a0d/0-168464.jpg__500x300_q85_subsampling-2.jpg',
      title: 'Сталинградская битва',
      link: 'https://xn--80abetlybeo6ie.xn--p1ai/themes/stalingradskaya-bitva/?page=1',
    },
  ],
};
